import api from './api';

export const userService = {
    // Get all users with pagination
    getUsers: async (page = 1, search = '') => {
        try {
            const response = await api.get('/users', {
                params: { page, search }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data user'
            };
        }
    },

    // Get single user
    getUser: async (id) => {
        try {
            const response = await api.get(`/users/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data user'
            };
        }
    },

    // Create user
    createUser: async (userData) => {
        try {
            const response = await api.post('/users', userData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat user'
            };
        }
    },

    // Update user
    updateUser: async (id, userData) => {
        try {
            const response = await api.put(`/users/${id}`, userData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate user'
            };
        }
    },

    // Delete user
    deleteUser: async (id) => {
        try {
            const response = await api.delete(`/users/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus user'
            };
        }
    },

    // Get roles
    getRoles: async () => {
        try {
            const response = await api.get('/roles');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data role'
            };
        }
    }
};